import styled from 'styled-components'

export const CompareWrapper = styled.div`
    --exposure: 0%;
    --thumb-size: 2.25rem;

    position: relative;
    width: 100%;
    max-width: none;
    margin: 1.5rem 0;
    overflow: hidden;
    border-radius: 0.75rem;
    background: white;
`

export const BaseImage = styled.img`
    display: block;
    width: 100%;
    height: auto;
`

export const Overlay = styled.div`
    position: absolute;
    inset: 0;
    background: white;

    clip-path: polygon(
            0 0,
            var(--exposure) 0,
            var(--exposure) 100%,
            0 100%
    );
`

export const OverlayImage = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
`

export const Divider = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: var(--exposure);
    width: 3px;
    transform: translateX(-50%);
    background: white;
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.35);
    pointer-events: none;
    z-index: 2;
`

export const SliderLabel = styled.label`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: stretch;
    z-index: 3;
`

export const SliderInput = styled.input`
    width: 100%;
    appearance: none;
    -webkit-appearance: none;
    background: transparent;
    cursor: col-resize;

    &:focus {
        outline: none;
    }

    &::-webkit-slider-runnable-track {
        height: 100%;
        background: transparent;
    }

    &::-moz-range-track {
        height: 100%;
        background: transparent;
    }

    /*
      Hide the browser's default circular thumb.
      We will render our own arrow handle.
    */
    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: var(--thumb-size);
        height: var(--thumb-size);
        border: 0;
        border-radius: 50%;
        background: transparent;
        box-shadow: none;
    }

    &::-moz-range-thumb {
        width: var(--thumb-size);
        height: var(--thumb-size);
        border: 0;
        border-radius: 50%;
        background: transparent;
        box-shadow: none;
    }

    &:focus::-webkit-slider-thumb {
        outline: none;
    }

    &:focus::-moz-range-thumb {
        outline: none;
    }
`

export const ArrowHandle = styled.div`
    position: absolute;
    top: 0.75rem;
    width: var(--thumb-size);
    height: var(--thumb-size);
    border: 3px solid white;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.55);
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.35);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(-50%);
    pointer-events: none;
    z-index: 4;
    font-size: 1rem;
`

export const VisuallyHidden = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
    border: 0;
`

export const Caption = styled.p`
    width: 100%;
    max-width: none;
    margin: 0.75rem 0 0;
    font-size: 0.95rem;
    line-height: 1.5;
    text-align: center;
`


// WEBPACK FOOTER //
// ./src/components/ImageComparisonSlider/styles.js